import { render, staticRenderFns } from "./RsvpInvites.vue?vue&type=template&id=46c4a2b8&scoped=true&"
import script from "./RsvpInvites.vue?vue&type=script&lang=js&"
export * from "./RsvpInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c4a2b8",
  null
  
)

export default component.exports